import React from 'react';
export function HomeSmallIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.579 8.2l-8.992-6.013a1 1 0 00-1.109 0L2.469 8.172a1 1 0 101.107 1.666L4 9.558 3.98 21a1 1 0 001 1l5.02.01a1 1 0 001-1l.01-4.01A1 1 0 1113 17l-.01 4a1 1 0 001 1l5.01.01c.263-.012.513-.115.708-.29a1 1 0 00.292-.708l.018-11.449.448.3A1 1 0 1021.579 8.2zM18 20.008L14.992 20 15 17a3.009 3.009 0 00-2.932-3h-.08a3.01 3.01 0 00-2.978 3L9 20.008 5.981 20 6 8.227l6.029-4.007 5.991 4.007L18 20.008z"
  }));
}